(function ($) {

	$(function () {

		/** =============================================
		 *  WP ADMIN BAR FIX
		 *  ============================================= */

		//push site down if wp admin navbar is active
		if ($("#wpadminbar").length > 0) {
			if ($(window).width() <= 782) {
				$("nav.navbar").css("margin-top", "46px");
			}
			else {
				$("nav.navbar").css("margin-top", "32px");
			}
		}

		/** =============================================
		 *  NAVBAR THINGS
		 *  ============================================= */

		var navbar = $('.navbar');

		function setNavbar(window) {

			//if the user has scrolled down a bit, add a scrolled class to the navbar
			if (window.scrollTop() > 10) {
				navbar.addClass('scrolled');
			} else {
				navbar.removeClass('scrolled');
			}
		}

		var lastScrollTop = 0;

		function setScrollDirection(window) {
			var currentScrollTop = window.scrollTop();

			//if currentscrolltop is bigger than last, the user is scrolling down
			if (currentScrollTop > lastScrollTop) {
				if (navbar.hasClass('scrolling-up')) {
					navbar.removeClass('scrolling-up');
				}
				navbar.addClass('scrolling-down');
			}
			//if currentscrolltop is smaller than last, the user is scrolling up
			else {
				if (navbar.hasClass('scrolling-down')) {
					navbar.removeClass('scrolling-down');
				}
				navbar.addClass('scrolling-up');
			}
			lastScrollTop = currentScrollTop;
		}

		$(window).on('scroll', function () {
			setNavbar($(this));
			setScrollDirection($(this));
		});

		//if the user refreshes the page when it's scrolled down
		if ($(window).scrollTop() > 0) {
			navbar.addClass('scrolling-up').addClass("scrolled");
		}

		//if mobile navbar is showing, add a class to our navbar to make it kinda transparent
		$('#MyNavbar').on('hide.bs.collapse', function () {
			$("nav.navbar").removeClass("navbar-toggled");
		});

		$('#MyNavbar').on('show.bs.collapse', function () {
			$("nav.navbar").addClass("navbar-toggled");
		});

	});

})(jQuery);